import { api } from './client'
import { getDeviceName, getDevicePlatform, type DeviceIdentity } from '../device'

export interface MyDevice {
  id: string
  deviceId: string
  deviceName: string | null
  platform: string | null
  status: 'PENDING' | 'APPROVED' | 'REJECTED' | 'REVOKED'
  isActive: boolean
  approvedAt: string | null
  createdAt: string
}

/**
 * 기기 등록 요청.
 *
 * ⚠️ legacyDeviceId 는 보내지 않는다 — 자동 재매핑이 폐기(DEVICE_REMAP_GUARD=on)됐고,
 *    보내면 서버에 remap BLOCKED 로그만 쌓인다. 스펙 §5-4 참조.
 */
export function registerDevice(identity: Extract<DeviceIdentity, { source: 'native' | 'browser' }>) {
  return api<MyDevice>('/api/devices/register', {
    method: 'POST',
    body: JSON.stringify({
      deviceId: identity.id,
      deviceName: getDeviceName(),
      platform: getDevicePlatform(),
    }),
  })
}

export function getMyDevices() {
  return api<MyDevice[]>('/api/devices/my')
}

export function getActiveDevice() {
  return api<MyDevice | null>('/api/devices/active')
}

/** 태깅 전 기기 검증 */
export function verifyDevice(deviceId: string) {
  return api<{ valid: boolean; reason?: string }>('/api/devices/verify', {
    method: 'POST',
    body: JSON.stringify({ deviceId }),
  })
}

/** 본인 PENDING 요청 철회 — 승인 대기에 묶였을 때의 출구 */
export function cancelPendingDevice(id: string) {
  return api<{ message: string }>(`/api/devices/my/${id}`, { method: 'DELETE' })
}
